import { format, startOfDay, startOfMonth, startOfWeek, startOfYear, subDays } from 'date-fns';

export function createFilterEQL(params: { [key: string]: any }) {
  const searchElements: string[] = [];
  const { created_after, lead_order_status, ...paramsForEQL } = params;

  // `filter_order_lists=all` is a frontend-only value used to keep the "All" tab
  // reflected in the URL. The backend equivalent is omitting the filter entirely.
  if (paramsForEQL.filter_order_lists === 'all') paramsForEQL.filter_order_lists = '';

  if (created_after) paramsForEQL.created_at = calculateCreatedAt(created_after);

  paramsForEQL.lead_order_status = lead_order_status === 'draft' ? '' : lead_order_status;
  if (lead_order_status === 'draft') paramsForEQL.is_draft = 1;

  for (let key in paramsForEQL) {
    let val = paramsForEQL[key];
    if ([undefined, null, ''].includes(val)) continue;
    const valType = typeof val;

    if (valType === 'string') {
      if (key === 'created_at') val = `["${val}" TO *]`;
      else val = `"${val}"`;
    } else if (valType === 'boolean') val = val.toString();
    else if (Array.isArray(val) && val.length) val = val.map((el) => `"${el}"`);
    else if (valType === 'number' && key === 'creator_string') val = `"customer.account:${val}"`;
    else if (valType === 'object') continue;

    if (key.startsWith('not$')) {
      //Example: paramsForEQL.not$is_draft = 1;
      key = key.replace('not$', 'NOT ');
    }

    searchElements.push(`(${key}: ${val})`);
  }

  return searchElements.join(' AND ');
}
export function createURLQueryList(params: { [key: string]: any }, existingQueryParams: { [key: string]: any }) {
  const queryParams = { ...existingQueryParams };

  for (const key in params) {
    let val = params[key];
    if ([undefined, null, ''].includes(val)) val = undefined;

    queryParams[key] = val;
  }

  return queryParams;
}

/**
 * Counts how many of the given keys hold a non-empty value on `filters`.
 * A value is empty when it's null/undefined/'' or an empty array.
 * Callers pick which keys count as "filters" (e.g. FilterButton's popover
 * fields, or a broader set including the search query and tab).
 */
export function countActiveFilters(filters: Record<string, any> | null | undefined, keys: readonly string[]): number {
  if (!filters) return 0;
  return keys.reduce((count, key) => {
    const value = filters[key];
    if (Array.isArray(value)) return count + (value.length > 0 ? 1 : 0);
    return count + (value != null && value !== '' ? 1 : 0);
  }, 0);
}

export function calculateCreatedAt(value: string) {
  let dateFilter: Date;
  const today = new Date();

  if (!value) return ''; // everything

  if (value === 'today') dateFilter = startOfDay(today);
  else if (value === 'this_week') dateFilter = startOfWeek(today);
  else if (value === 'this_month') dateFilter = startOfMonth(today);
  else if (value === 'this_year') dateFilter = startOfYear(today);
  else if (value === '7days') dateFilter = subDays(today, 7);
  else if (value === '30days') dateFilter = subDays(today, 30);
  else if (value === '90days') dateFilter = subDays(today, 90);
  else dateFilter = startOfDay(today);

  return format(dateFilter, 'yyyy-MM-dd 00:00:00');
}
